// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vy_a bhh_b bhh_wb"};